/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const WeaknessIcon = props => {
	const { color = '' } = props
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 50 50'
			style={{
				enableBackground: 'new 0 0 50 50'
			}}
			xmlSpace='preserve'
			width='1em'
			height='1em'
			fill={color}
			{...props}
		>
			<path d='M25 0C11.2 0 0 11.2 0 25s11.2 25 25 25 25-11.2 25-25S38.8 0 25 0zm0 48.2C12.2 48.3 1.8 37.8 1.8 25 1.7 12.2 12.2 1.8 25 1.8S48.2 12.2 48.2 25c0 12.8-10.4 23.2-23.2 23.2z' />
			<path d='M25.6 27.7c-4.4 0-8.3 2.9-9.6 7.1v.2c0 .5.4.9.9.9.4 0 .7-.3.9-.6 1.1-3.5 4.3-5.8 7.9-5.8 3.6 0 6.8 2.3 7.9 5.8.1.4.6.7 1.1.6.5-.1.8-.6.7-1.1-1.6-4.2-5.4-7.1-9.8-7.1zM12.8 16.1c-.4-.3-.9-.2-1.2.2-.3.4-.2.9.2 1.2l4.1 3-4.6 2c-.4.2-.6.6-.5 1 .1.5.6.7 1 .6h.1l7.4-3.2-6.5-4.8zM39.2 22.5l-4.5-2.1 4-2.9h.1c.4-.3.4-.8.1-1.2-.3-.4-.8-.4-1.2-.1l-6.4 4.6 7.2 3.3c.1 0 .1 0 .2.1.4.1.8-.1 1-.5.1-.5-.1-1-.5-1.2z' />
		</svg>
	)
}

export default WeaknessIcon
